import { useEffect } from "react";
import { connect } from "react-redux";
import { tokenize } from "../../actions/auth";
import { consumeCheckoutReturnPath } from "../../utils/checkout";

export const tokenizeRequest = (search = "") => {
    const params = new URLSearchParams(search);
    const token = params.get("t");
    const secure = params.get("s") === "1";
    const address = params.get("a");
    const port = params.get("p");
    const url = address
        ? `http${secure ? "s" : ""}://${address}${port ? `:${port}` : ""}/`
        : null;

    return { token, url };
};

export const completeTokenize = async ({
    search = window.location.search,
    tokenize: persistToken,
    history,
    storage = sessionStorage
}) => {
    const { token, url } = tokenizeRequest(search);
    if (!token) {
        console.error("Tokenize failed: missing token.");
        return false;
    }

    try {
        if (await persistToken(token, url)) {
            history.replace(consumeCheckoutReturnPath(storage));
            return true;
        }
    } catch (err) {
        console.error("Tokenize failed.", err);
    }

    return false;
};

export const Tokenize = ({ tokenize, history }) => {
    useEffect(() => {
        completeTokenize({ tokenize, history });
    }, [tokenize, history]);

    return null;
};

export default connect(null, { tokenize })(Tokenize);

